import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dental-chart",
  templateUrl: "./dental-chart.component.html",
  styleUrls: ["./dental-chart.component.scss"],
})
export class DentalChartComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
